import { ChangeDetectionStrategy, Component, computed, input, linkedSignal, model } from '@angular/core';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { TextLinkActionComponent } from '@reconcept-platform/shared/ui/standalone/button';

@Component({
  selector: 'rcp-box-expandable',
  template: `
    <div class="box-expandable" [style.max-height]="maxHeight()">
      <ng-content></ng-content>
    </div>

    @if (expanded() && totalNumberOfItems() > initialVisibleItems()) {
      <div class="button-expand-container">
        <rcp-text-link-action (click)="collapse()" [icon]="faAngleUp">
          {{ 'qz-show-less-zm' | translate }}
        </rcp-text-link-action>
      </div>
    } @else if (!expanded() && totalNumberOfItems() > visibleItems()) {
      <div class="button-expand-container">
        <rcp-text-link-action (click)="toggleExpanded()" [icon]="faAngleDown">
          {{ 'qz-show-more-zm' | translate }}
        </rcp-text-link-action>
      </div>
    }
  `,
  styleUrls: ['./box-expandable.component.scss'],
  imports: [TranslatePipe, TextLinkActionComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoxExpandableComponent {
  readonly totalNumberOfItems = input.required<number>();
  readonly expanded = model(false);
  readonly initialVisibleItems = input(3);
  readonly rowHeight = input(60);
  readonly increment = input<number>();

  readonly visibleItems = linkedSignal(() => this.initialVisibleItems());

  readonly maxHeight = computed(() => (this.expanded() ? 'none' : this.visibleItems() * this.rowHeight() + 'px'));

  toggleExpanded() {
    const increment = this.increment();
    if (increment != null) {
      this.visibleItems.update((v) => v + increment);
      if (this.visibleItems() >= this.totalNumberOfItems()) {
        this.expanded.set(true);
      }
    } else {
      this.expanded.update((v) => !v);
    }
  }

  collapse() {
    this.visibleItems.set(this.initialVisibleItems());
    this.expanded.set(false);
  }

  protected readonly faAngleDown = faAngleDown;
  protected readonly faAngleUp = faAngleUp;
}
